// Profile Data & Functions
const md5 = require('md5');

export const fields = {
  photo: {
    toggle: true,
    value: null,
    loading: false,
    disabled: false,
  },
  fullname: {
    toggle: true,
    value: null,
    loading: false,
    disabled: false,
    label: 'profile.personal.fullname',
    success: false,
    error: false,
    rules: [v => !!v && v != null || 'general.mandatory_field', v => {
      return /[\p{L}\p{M}]{3,}\W([\p{L}\p{M}]{2,}\W[\p{L}\p{M}]{2,}|[\p{L}\p{M}]{2,})/u.test(v) || 'profile.rules.fullname_please';
    }],
  },
  email: {
    toggle: true,
    value: null,
    loading: false,
    disabled: false,
    label: 'profile.personal.email',
    success: false,
    error: false,
    rules: [v => !!v && v != null || 'general.mandatory_field', v => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(v) || 'profile.rules.invalid_email'
    }],
  },
  cpf: {
    toggle: true,
    value: null,
    mask: '###.###.###-##',
    label: 'profile.personal.social_id',
    loading: false,
    disabled: true,
    rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field'],
    regex: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/,
    success: false,
    error: false,
  },
  rg: {
    id: {
      toggle: false,
      value: null,
      mask: '########-#',
      loading: false,
      disabled: true,
      label: 'profile.personal.id_number',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
    },
    issuer: {
      toggle: false,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.personal.id_issuer',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
    }
  },
  cnh: {
    toggle: false,
    value: null,
    loading: false,
    disabled: true,
    label: 'profile.personal.drivers_license',
    success: false,
    error: false,
    rules: [v => !!v && v != null || 'general.mandatory_field'],
  },
  phone: {
    toggle: true,
    value: null,
    mask: '+55 (##) #####-####',
    loading: false,
    disabled: false,
    label: 'profile.personal.phone',
    hint: 'profile.personal.phone_hint',
    success: false,
    error: false,
    rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field'],
    regex: /[0-9]{13}|^(?:\+)[0-9]{2}\s?(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/,
  },
  birthdate: {
    toggle: true,
    value: null,
    mask: '##/##/####',
    loading: false,
    disabled: false,
    label: 'profile.personal.birthdate',
    hint: 'profile.personal.birthdate_hint',
    success: false,
    error: false,
    rules: [v => !!v || 'general.mandatory_field'],
  },
  gender: {
    toggle: true,
    value: null,
    loading: false,
    disabled: false,
    label: 'profile.personal.gender.label',
    success: false,
    error: false,
    rules: [v => v != null || 'general.mandatory_field'],
    items: [
      {
        text: 'profile.personal.gender.masculine',
        value: 'M'
      },
      {
        text: 'profile.personal.gender.feminine',
        value: 'F'
      },
      {
        text: 'profile.personal.gender.other',
        value: 'o'
      },
      {
        text: 'profile.personal.gender.undisclosed',
        value: '-'
      },
    ]
  },
  gps: {
    toggle: true,
    loading: false,
    disabled: true,
    label: 'profile.gps',
  },
  push: {
    toggle: true,
    loading: false,
    disabled: true,
    label: 'profile.push',
  },
  address: {
    street: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.street',
      hint: 'profile.personal.address.street_hint',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'general.mandatory_field'],
    },
    number: {
      toggle: true,
      value: null,
      mask: '######',
      loading: false,
      disabled: false,
      label: 'profile.personal.address.number',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
    },
    compl: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.compl',
      hint: 'profile.personal.address.compl_hint',
      success: false,
      rules: []
    },
    neighborhood: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.neighborhood',
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
    },
    zip: {
      toggle: true,
      value: null,
      mask: '#####-###',
      loading: false,
      disabled: false,
      label: 'profile.personal.address.zip_code',
      hint: '',
      success: false,
      error: false,
      rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field',
      ],
      regex: /^([\d]{2})\.*([\d]{3})-*([\d]{3})/,
    },
    city: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.city',
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'general.mandatory_field'],
    },
    state: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.state',
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v || 'general.mandatory_field'],
      items: []
    },
    country: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.personal.address.country',
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 2 || 'general.mandatory_field'],
    },
  },
  job: {
    products: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.products.label',
      placeholder: 'profile.job.products.placeholder',
      success: false,
      error: false,
      rules: [v => v != null && v.length > 0 || 'general.mandatory_field'],
      items: [
        {
          text: 'BUZZER_DIGITAL',
          value: 'BUZZER_DIGITAL'
        },
        {
          text: 'BUZZER_PRINT',
          value: 'BUZZER_PRINT'
        },
        {
          text: 'WRAPPING_WINDOW',
          value: 'WRAPPING_WINDOW'
        },
        {
          text: 'WRAPPING_BODYWORK',
          value: 'WRAPPING_BODYWORK'
        },
      ]
    },
    special_projects: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.special_projects.label',
      placeholder: 'profile.job.special_projects.placeholder',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.job.special_projects.yes',
          value: 1
        },
        {
          text: 'profile.job.special_projects.no',
          value: 0
        },
      ],
    },
    apps: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.apps.label',
      placeholder: 'profile.job.apps.placeholder',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length > 0 || 'general.mandatory_field'],
      items: [
        {
          text: '99',
          value: '99'
        },
        {
          text: 'Uber',
          value: 'UBER'
        },
        {
          text: 'InDriver',
          value: 'INDRIVER'
        },
        {
          text: 'TAXI.RIO',
          value: 'TAXIRIO'
        },
        {
          text: 'Outros',
          value: 'Outros'
        },
        {
          text: 'Nenhum',
          value: 'Nenhum',
          nil: true
        },
      ]
    },
    apps_percent: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.apps_percent.label',
      placeholder: 'profile.job.apps_percent.placeholder',
      success: false,
      error: false,
      rules: [(v,$) => (!$.fields.job.apps.value||$.fields.job.apps.value.length<=1) || (!!v && v != null && !Object.values(v).reduce((unset, app) => unset || app.value == null, false)) || 'general.mandatory_field'],
      items: [],
      options: [
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
      ],
    },
    service_model: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.service_model.label',
      placeholder: 'profile.job.service_model.placeholder',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.job.service_model.App',
          caption: 'profile.job.service_model.App_hint',
          value: 'App'
        },
        {
          text: 'profile.job.service_model.Tx',
          caption: 'profile.job.service_model.Tx_hint',
          value: 'Tx'
        },
        {
          text: 'profile.job.service_model.Dlv',
          caption: 'profile.job.service_model.Dlv_hint',
          value: 'Dlv'
        },
        // {
        //   text: 'Categoria X',
        //   subtitle: 'Atendo corridas X e/ou similares',
        //   value: 'X'
        // },
        // {
        //   text: 'Categoria Black',
        //   subtitle: 'Atendo corridas Black e/ou similares',
        //   value: 'B'
        // },
        // {
        //   text: 'Categoria X e Black',
        //   subtitle: 'Atendo ambas, porém mais corridas X',
        //   value: 'Xb'
        // },
        // {
        //   text: 'Categoria Black e X',
        //   subtitle: 'Atendo ambas, porém mais corridas Black',
        //   value: 'Bx'
        // },
      ]
    },
    fulltime: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.fulltime.label',
      hint: 'profile.job.fulltime.label_abbv',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.job.fulltime.full_time',
          value: 1
        },
        {
          text: 'profile.job.fulltime.part_time',
          value: 0
        },
      ]
    },
    journey: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.journey.label',
      hint: '',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.job.journey.8-',
          value: 2
        },
        {
          text: 'profile.job.journey.8-12',
          value: 1
        },
        {
          text: 'profile.job.journey.12+',
          value: 0
        },
      ]
    },
    region: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.region.label',
      placeholder: 'profile.job.region.placeholder',
      hint: '',
      success: false,
      error: false,
      rules: [v => v != null && v.length >= 3 || 'general.mandatory_field'],
      items: [
        { header: 'RJ' },
        {
          title: 'Rio de Janeiro/Zona Sul',
          group: 'RJ'
        },
        {
          title: 'Rio de Janeiro/Zona Norte',
          group: 'RJ'
        },
        {
          title: 'Rio de Janeiro/Zona Oeste',
          group: 'RJ'
        },
        {
          title: 'Rio de Janeiro/Centro',
          group: 'RJ'
        },
        {
          title: 'Baixada',
          group: 'RJ'
        },
        {
          title: 'Niterói',
          group: 'RJ'
        },
        { header: 'Outras regiões' },
      ], // TODO: i18n items
      filter: (item, query, text) => {
        if ('title' in item) {
          const normalized = item.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
          return new RegExp(query.toLowerCase()).test(normalized);
        }else{
          return false;
        }
      },
    },
    rating: {
      toggle: true,
      value: null,
      mask: '#.##',
      loading: false,
      disabled: false,
      label: 'profile.job.rating.label',
      hint: 'profile.job.rating.hint',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field',
        v => /^[0-5]*\.[0-9]{2}$/.test(v) || 'profile.rules.rating_format',
        v => v <= 5 || 'profile.rules.rating_max'
      ],
    },
    experience: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.job.experience.label',
      hint: 'profile.job.experience.hint',
      max: 120,
      rules: [v => v != null || v > 0 || 'general.mandatory_field'],

    },
  },
  vehicle: {
    plate: {
      toggle: true,
      value: null,
      mask: 'AAA-#X##',
      loading: false,
      disabled: true,
      label: 'profile.vehicle.plate',
      hint: '',
      success: false,
      error: false,
      regex: /^[a-zA-Z]{3}[0-9][A-Za-z0-9][0-9]{2}$/,
      rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field'],
    },
    chassis: {
      toggle: false,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.chassis',
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'general.mandatory_field'],
    },
    color: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.color.label',
      items: [
        { "value": "black", "text": "black" },
        { "value": "silver", "text": "silver" },
        { "value": "white", "text": "white" },
        { "value": "grey", "text": "grey" },
        { "value": "dark_grey", "text": "dark_grey" },
        { "value": "yellow", "text": "yellow" },
        { "value": "red", "text": "red" },
        { "value": "blue", "text": "blue" },
        { "value": "dark_blue", "text": "dark_blue" },
        { "value": "brown", "text": "brown" },
        { "value": "purple", "text": "purple" },
        { "value": "green", "text": "green" },
        { "value": "gold", "text": "gold" },
        { "value": "orange", "text": "orange" },
        { "value": "pink", "text": "pink" }
      ],
      hint: '',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'general.mandatory_field'],
    },
    // brand: {
    //   toggle: true,
    //   loading: false,
    //   disabled: true,
    //   label: 'Marca',
    //   hint: '',
    //   success: false,
    //   rules: [v => !!v && v!=null && v.length>=3 || 'general.mandatory_field'],
    //   items: [
    //     'Chevrolet',
    //     'Fiat',
    //     'Ford',
    //     'Honda',
    //     'Hyundai',
    //     'Jac',
    //     'Kia',
    //     'Mitsubishi',
    //     'Nissan',
    //     'Peugeot',
    //     'Renault',
    //     'Toyota',
    //     'Volkswagen',
    //   ]
    // },
    model: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.model.label',
      hint: 'profile.vehicle.model.hint',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'profile.rules.vehicle_model_please'],
      items: []
    },
    fuel: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.vehicle.fuel.label',
      placeholder: 'profile.vehicle.fuel.placeholder',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length > 0 || 'general.mandatory_field'],
      items: [
        { value: "natural_gas", text: "natural_gas" },
        { value: "gasoline", text: "gasoline" },
        { value: "alcohol", text: "alcohol" },
        { value: "eletric", text: "eletric" }
      ]
    },
    parking: {
      toggle: false,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.parking.label',
      hint: '',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.vehicle.parking.covered_garage',
          value: 0,
        },
        {
          text: 'profile.vehicle.parking.uncovered_garage',
          value: 1,
        },
        {
          text: 'profile.vehicle.parking.street',
          value: 2,
        },
      ]
    },
    year: {
      toggle: true,
      value: null,
      mask: '####',
      loading: false,
      disabled: true,
      label: 'profile.vehicle.year',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field',
      v => /^(19[5-9]\d|20[0-2]\d)$/.test(v) || 'profile.rules.invalid_year'
      ],
    },
    renavam: {
      toggle: false,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.vehicle_id',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field'],
    },
    isOwner: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.label',
      success: false,
      error: false,
      rules: [v => v != null || 'general.mandatory_field'],
      items: [
        {
          text: 'profile.vehicle.owner.owner',
          value: 1
        },
        {
          text: 'profile.vehicle.owner.borrowed',
          value: 0
        },
        {
          text: 'profile.vehicle.owner.rental',
          value: 2
        },
      ]
    },
    rental: {
      toggle: false,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.rental',
      rules: [v => v != null && v.length > 3 || 'general.mandatory_field'],
      success: false
    },
    ownerName: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.name',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length > 3 || 'general.mandatory_field'],
    },
    ownerEmail: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.email',
      success: false,
      error: false,
      rules: [v => !!v && v != null || 'general.mandatory_field', (v, $) => {
        const email = !_.isNil($) ? $.profile.email : profile.email;
        return v != email || 'profile.rules.owner_email';
      }, v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'profile.rules.invalid_email'
      }],
    },
    ownerRg: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.id_number',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length > 6 || 'general.mandatory_field'],
    },
    ownerOrg_exp: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.id_issuer',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length > 3 || 'general.mandatory_field'],
    },
    ownerCpf: {
      toggle: true,
      value: null,
      mask: '###.###.###-##',
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.social_id',
      success: false,
      error: false,
      rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field'],
      regex: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/,
    },
    ownerRelative: {
      toggle: true,
      value: null,
      loading: false,
      disabled: true,
      label: 'profile.vehicle.owner.relative',
      success: false,
      error: false,
      rules: [v => !!v && v != null && v.length >= 3 || 'general.mandatory_field'],
    },
  },
  payment: {
    pix: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.pix',
      rules: [v => v != null || 'general.mandatory_field'],
      hint: '',
      success: false
    },
    bank: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.bank',
      rules: [v => v != null || 'general.mandatory_field'],
      hint: '',
      success: false
    },
    branch: {
      toggle: true,
      value: null,
      mask: ['###', '###-#', '###-##'], // mask freezes the browser
      loading: false,
      disabled: false,
      label: 'profile.payment.branch',
      rules: [v => v != null || 'general.mandatory_field'],
      success: false
    },
    account: {
      toggle: true,
      value: null,
      // mask: ['###-#', '####-#', '#####-#', '######-#'], 
      loading: false,
      disabled: false,
      label: 'profile.payment.account',
      rules: [v => v != null || 'general.mandatory_field', v => v != '' || 'general.mandatory_field'],
      hint: 'profile.payment.account_hint',
      success: false
    },
    digit: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.account_digit',
      rules: [v => v != null && v != '' && v.length==1 || 'general.mandatory_field'],
      success: false
    },
    type: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.account_type.label',
      rules: [v => v != null || 'general.mandatory_field'],
      success: false,
      error: false,
      items: [
        {
          text: 'profile.payment.account_type.checking',
          value: 'COR'
        },
        {
          text: 'profile.payment.account_type.savings',
          value: 'POU',
          disabled: true
        },
      ]
    },
    compl: {
      toggle: true,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.account_compl',
      success: false
    },
    owner: null,
    name: {
      toggle: false,
      value: null,
      loading: false,
      disabled: false,
      label: 'profile.payment.account_name',
      rules: [(v,$) => $.fields?.payment?.owner || !!v && v.split(' ').length > 1 || 'general.mandatory_field'],
      success: false,
      error: false,
    },
    cpf: {
      toggle: false,
      value: null,
      mask: '###.###.###-##',
      loading: false,
      disabled: false,
      label: 'profile.payment.account_cpf',
      rules: [(v,$,regex) => !!v && (!regex || regex.test(v))|| 'general.mandatory_field'],
      regex: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/,
      success: false,
      error: false,
    },
  },
}

export const completion = {
  'REG': {
    personal: {
      percent: 0,
      inherit: [],
      required: [
        'fullname',
        'email',
        'cpf',
        'phone',
        'address.zip',
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: [],
      required: [
        'job.service_model',
        'job.fulltime',
        'job.journey',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: [],
      required: [
        'vehicle.model',
        'vehicle.year',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      required: [],
      disabled: [],
    }
  },
  'ACCX': {
    personal: {
      percent: 0,
      inherit: [],
      required: [
        'fullname',
        'email',
        'cpf',
        'phone',
        'birthdate',
        'address.zip',
        'address.neighborhood',
        'address.street',
        'address.number',
        'address.compl',
        'address.city',
        'address.state',
        'address.country',
      ],
      disabled: [
        'cpf',
      ],
    },
    job: {
      percent: 0,
      inherit: [],
      required: [
        'job.service_model',
        'job.fulltime',
        'job.journey',
        'job.rating',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: [],
      required: [
        'vehicle.model',
        'vehicle.year',
        'vehicle.plate',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      required: [
        'payment.pix',
      ],
      disabled: [],
    }
  },
  'ACC': {
    personal: {
      percent: 0,
      inherit: [],
      required: [
        'fullname',
        'email',
        'phone',
        'birthdate',
        'gender',
        'address.zip',
        'address.neighborhood',
        'address.street',
        'address.number',
        'address.compl',
        'address.city',
        'address.state',
        'address.country',
      ],
      disabled: [
        'cpf',
      ],
    },
    job: {
      percent: 0,
      inherit: [],
      required: [
        'job.service_model',
        'job.fulltime',
        'job.journey',
        'job.rating',
        'job.experience',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: [],
      required: [
        // 'vehicle.brand',
        'vehicle.model',
        'vehicle.year',
        'vehicle.isOwner',
        // 'vehicle.ownerRelative',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      required: [],
      disabled: [],
    }
  },
  'FDB': {
    personal: {
      percent: 0,
      inherit: [],
      required: [
        'fullname',
        'cpf',
        'email',
        'phone',
        'birthdate',
        'address.zip',
        'address.city',
        'address.state',
        'address.country',
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: [],
      required: [
        'job.service_model',
        'job.fulltime',
        'job.journey',
        'job.rating',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: [],
      required: [
        // 'vehicle.brand',
        'vehicle.model',
        'vehicle.year',
        'vehicle.plate',
        'vehicle.color',
        // 'vehicle.isOwner',
        // 'vehicle.ownerRelative',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      required: [],
      disabled: [],
    }
  },
  'FDBX': 'FDB',
  'SIG': {
    personal: {
      percent: 0,
      inherit: ['ACC'],
      required: [
        'rg.id',
        'rg.issuer',
        'cnh',
        'address.neighborhood',
        'address.street',
        'address.number',
        'address.compl',
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ACC'],
      required: [],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ACC'],
      required: [
        'vehicle.plate',
        'vehicle.color',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ACC'],
      required: [],
      disabled: [],
    },
  },
  'ENR': {
    personal: {
      percent: 0,
      inherit: ['ACC'],
      required: [
        'address.neighborhood',
        'address.street',
        'address.number',
        'address.compl',
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ACC'],
      required: [],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ACC'],
      required: [
        'vehicle.plate',
        'vehicle.color',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      required: [
        'payment.pix',
        'payment.bank',
        'payment.branch',
        'payment.account',
        'payment.digit',
        // 'payment.type',
        'payment.compl',
        // 'payment.name',
        // 'payment.cpf',
      ],
      disabled: [],
    }
  },
  'FDD': {
    personal: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
  },
  'REA': {
    personal: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
  },
  'SCH': {
    personal: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
  },
  'ACT': {
    personal: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [
        'gender'
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [
        'job.apps',
        'job.apps_percent',
        'job.experience',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [
        'vehicle.fuel',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ENR', 'ACC'],
      required: [],
      disabled: [],
    },
  },
  'EXP': {
    personal: {
      percent: 0,
      inherit: ['ENR', 'ACC', 'ACT'],
      required: [
        'gender'
      ],
      disabled: [],
    },
    job: {
      percent: 0,
      inherit: ['ENR', 'ACC', 'ACT'],
      required: [
        'job.apps',
        'job.apps_percent',
        'job.experience',
      ],
      disabled: [],
    },
    vehicle: {
      percent: 0,
      inherit: ['ENR', 'ACC', 'ACT'],
      required: [
        'vehicle.parking',
        'vehicle.fuel',
      ],
      disabled: [],
    },
    payment: {
      percent: 0,
      inherit: ['ENR', 'ACC', 'ACT'],
      required: [],
      disabled: [],
    },
  }
}

export const defaults = {
  hive: {
    'id': 1,
    'name': 'Rio',
    'address': 'R. Viêira Ferreira, 55 - Bonsucesso',
    'city': 'Rio de Janeiro/RJ'
  }
}

export const formatter = (data, $) => {
  _.each(data, (value, key) => {
    switch (key) {
      case 'rg.issuer':
        data[key] = value.toUpperCase();
        break;
      case 'fullname':
      case 'vehicle.ownerName':
      case 'payment.name':
        data[key] = value.split(' ').map(word => word.length > 2 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()).join(' ');
        break;
      case 'phone':
      case 'cpf':
      case 'rg.id':
      case 'vehicle.ownerRg':
      case 'vehicle.ownerCpf':
      case 'address.zip':
        data[key] = $.rawData(value);
        break;
      case 'vehicle.plate':
        data[key] = $.rawData(value).toUpperCase();
        break;
      case 'job.rating':
        data[key] = parseFloat(value);
        break;
      case 'job.apps':
      case 'job.products':
      case 'vehicle.fuel':
        data[key] = value.toString();
        break;
      case 'vehicle.model':
        if (value===null) break
        if (value=='Outro') {
          value = 'Outros Outros';
        }
        const combo = value.split(' ');
        data['vehicle.brand'] = combo.shift();
        data[key] = combo.join(' ');
        break;
      default:
        // value = value;
    }
  });
  return data;
}

export const parser = (data, $) => {
  let profile = {
    id: data.id_motorista,
    partner: data.parceiro && data.status_motorista=='ACT',
    partner_id: data.id_parceiro,
    fullname: $.normalize(data.nm_motorista),
    photo: data.foto_motorista,
    gender: data.genero,
    signedupAt: $.$moment.utc(data.dt_criacao).local().format('YYYY-MM-DD').toString(),
    birthdate: $.$moment(data.dt_nasc_motorista).isValid() ? $.$moment(data.dt_nasc_motorista).format('DD/MM/YYYY').toString() : null,
    cpf: data.cpf_motorista,
    viewedAt: data.viewedAt,
    email: data.email_motorista,
    phone: data.wpp_motorista,
    cnh: data.cnh_motorista,
    club_id: _.has(data, 'id_parceiro')&&data.id_parceiro!=null ? md5(data.id_parceiro.toString()).substr(0, 10) : null,
    rg: {
      id: data.rg_motorista,
      issuer: data.org_exp_motorista,
    },
    gps: data.gps,
    push: data.notific,
    badges: _.isNil(data.badges) ? null : data.badges,
    inactive: data.inatividade,
    fleet: data.fleet || {
      'id': 1,
      'id_organization': 1
    },
    hive: data.hive===null ? defaults.hive : data.hive,
    tags: _.split(data.tags, ',')||[],
    job: {
      products: _.isNil(data.products_interest)||data.products_interest=='' ? null : data.products_interest.split(','),
      special_projects: data.special_projects_interest,
      apps: _.isNil(data.app_work)||data.app_work=='' ? null : data.app_work.split(','),
      apps_percent: data.app_work_percent,
      service_model: !!data.mod_trab ? ['X', 'B', 'Xb', 'Bx'].includes(data.mod_trab) ? 'App' : data.mod_trab : null,
      fulltime: data.nivel_env,
      region: data.regiao_rodada,
      rating: data.nota_app == null ? null : data.nota_app.toFixed(2),
      journey: data.nr_rodadas,
      experience: data.tempo_motorista,
    },
    buzzer: {
      id: data.id_device,
      code: data.cod_device,
      number: data.nr_patrimonio,
      reviewedAt: data.dt_revisao,
      absences: {
        noShows: _.isNil(data.anotacoes) ? 0 : data.anotacoes.faltas,
        reschedules: _.isNil(data.anotacoes) ? 0 : data.anotacoes.remarcacoes
      }
    },
    address: {
      country: data.pais,
      state: data.uf,
      city: data.cidade,
      zip: data.cep,
      neighborhood: data.bairro,
      street: data.logradouro,
      number: data.numero,
      compl: data.complemento
    },
    vehicle: {
      id: data.id_veiculo,
      parking: data.estacionamento,
      plate: data.placa,
      chassis: data.chassi,
      brand: data.marca,
      model: data.marca + ' ' + data.modelo,
      year: data.ano_fab,
      color: $.normalizeField('profile.vehicle.color', data.cor),
      fuel: $.normalizeField('profile.vehicle.fuel', _.isNil(data.fuel_type)||data.fuel_type=='' ? null : data.fuel_type.split(',')),
      renavam: data.renavam,
      isOwner: data.dono,
      rental: data.nm_locadora,
      ownerName: data.nm_prop,
      ownerEmail: data.email_prop,
      ownerRg: data.rg_prop,
      ownerOrg_exp: data.org_exp_prop,
      ownerCpf: data.cpf_prop,
      ownerRelative: data.parent_prop,
    },
    payment: {
      pix: data.chave_pix,
      bank: data.id_banco,
      branch: data.agencia,
      account: data.conta,
      digit: data.dv,
      type: data.tipo_conta,
      compl: data.comp_conta,
      name: data.nm_titular_conta,
      cpf: data.cpf_titular_conta,
    },
  }

  if ($.fields) $.fields.payment.owner = data.nm_titular_conta==null || data.nm_titular_conta=='';

  profile.vehicle.model = profile.vehicle.model.trim();
  if (profile.vehicle.model=='Outros Outros') {
    profile.vehicle.model = 'Outro';
  }

  return profile;
}

export default {
  fields,
  completion,
  defaults,
  formatter,
  parser,
}